<template>
  <span class="profile">
    <div class="profile__header">
      <div class="row">
        <div class="col-4 cloud-l"></div>
        <div class="col-4">
          <img class="profile_avatar" :src="userAvatar" />
        </div>
        <div class="col-4 cloud-r"
             v-if="!isEditMode()"
             @click.prevent="toEdit()"
             style="cursor: pointer" >
           <img class="profile_edit_button" src="static/images/edit-profile.svg" />
        </div>
        <div class="col-12 profile_username">{{ getDisplayUsername }}</div>
        <div :class="['col-12 profile_username_info_msg']" v-if="hasFb()">
        {{ getTranslations.visitor_facebook_login_connect_before_points }} {{ connectionPoints }} {{ getTranslations.visitor_facebook_login_connect_after_points }}        </div>
        <div class="col-12 profile_connect_fb" v-if="hasFb()">
          <facebook-login :enteredUsername="userDetails.username"
                          :errorsInFb="errorInFb"
                          @errorsUpdated="methodForEvent($event)"
                          :type="fbActionType">
          </facebook-login>
          <span class="custom_fb_error_msg"
                v-if="errorInFb">{{ getTranslations.home_store_this_fb }}
          </span>
        </div>
      </div>
      <edit-avatar v-if="isEditMode()"></edit-avatar>
      <profile-stats v-else></profile-stats>
    </div>
    <router-view></router-view>
  </span>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import FacebookLogin from '@/components/visitor/FacebookLogin';
import ProfileStats from './ProfileStats';
import EditAvatar from './EditAvatar';

export default {
  name: 'profile',
  data() {
    return {
      fbActionType: 'connect',
      errorInFb: false,
    };
  },
  components: {
    ProfileStats,
    EditAvatar,
    FacebookLogin,
  },
  methods: {
    getFbMessage() {
      return this.getTranslations.visitor_sign_up_3_fb_username_first;
    },
    methodForEvent(event) {
      this.errorInFb = event;
    },
    toEdit() {
      this.$router.push('/home/profile/edit');
    },
    isEditMode() {
      return this.$route.path === '/home/profile/edit';
    },
    hasFb() {
      return this.$route.path === '/home/profile'
        && !this.userDetails.facebookId
        && this.facebookFunctionality;
    },
  },
  computed: {
    getDisplayUsername() {
      return this.userDetails.username;
    },
    ...mapState('common', [
      'userDetails',
      'userAvatar',
      'connectionPoints',
      'facebookFunctionality',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/Profile.vue